module.exports = __webpack_public_path__ + "img/Umb44_uv_logotie_4783.2c938e6f.svg";